import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking"); // checking | paid | pending | error

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (attempts >= 8) { setStatus("pending"); return; }
        setTimeout(poll, 2000);
      } catch {
        if (attempts >= 8) setStatus("error"); else setTimeout(poll, 2000);
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="grid min-h-screen place-items-center bg-background p-6" data-testid="payment-success-page">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center">
        {status === "checking" && <><Loader2 className="mx-auto h-12 w-12 animate-spin text-gold-400" /><h1 className="mt-4 font-display text-2xl font-bold">Confirmation du paiement…</h1><p className="mt-2 text-sm text-muted-foreground">Un instant, nous validons votre abonnement.</p></>}
        {status === "paid" && <><CheckCircle2 className="mx-auto h-12 w-12 text-gold-400" /><h1 className="mt-4 font-display text-2xl font-bold">Abonnement activé !</h1><p className="mt-2 text-sm text-muted-foreground">Bienvenue chez CRÉRÉA. Votre opérateur avancé est prêt à récupérer votre chiffre d'affaires.</p><Button onClick={() => navigate("/app")} data-testid="go-dashboard-btn" className="mt-6 rounded-full bg-gold-500 text-black hover:bg-gold-400">Accéder au tableau de bord</Button></>}
        {status === "pending" && <><Loader2 className="mx-auto h-12 w-12 text-amber-400" /><h1 className="mt-4 font-display text-2xl font-bold">Paiement en cours</h1><p className="mt-2 text-sm text-muted-foreground">Le paiement est en cours de traitement. Vous recevrez une confirmation sous peu.</p><Button onClick={() => navigate("/app")} className="mt-6 rounded-full" variant="outline">Continuer</Button></>}
        {status === "error" && <><XCircle className="mx-auto h-12 w-12 text-red-400" /><h1 className="mt-4 font-display text-2xl font-bold">Session introuvable</h1><Button onClick={() => navigate("/")} className="mt-6 rounded-full" variant="outline">Retour à l'accueil</Button></>}
      </div>
    </div>
  );
}
